/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface LatestZeroMeasurementDto
 */
export interface LatestZeroMeasurementDto {
    /**
     * 
     * @type {boolean}
     * @memberof LatestZeroMeasurementDto
     */
    hasZeroMeasurement?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LatestZeroMeasurementDto
     */
    latestExecutionTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LatestZeroMeasurementDto
     */
    zeroMeasurementValidityDuration?: number;
    /**
     * 
     * @type {string}
     * @memberof LatestZeroMeasurementDto
     */
    $type?: LatestZeroMeasurementDtoTypeEnum;
}


/**
 * @export
 */
export const LatestZeroMeasurementDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMeasurementComponentDtoLatestZeroMeasurementDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MeasurementComponent.Dto.LatestZeroMeasurementDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type LatestZeroMeasurementDtoTypeEnum = typeof LatestZeroMeasurementDtoTypeEnum[keyof typeof LatestZeroMeasurementDtoTypeEnum];



/**
 * Check if a given object implements the LatestZeroMeasurementDto interface.
 */
export function instanceOfLatestZeroMeasurementDto(value?: unknown): value is LatestZeroMeasurementDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(LatestZeroMeasurementDtoTypeEnum)[0];
}

export function LatestZeroMeasurementDtoFromJSON(json: any): LatestZeroMeasurementDto {
    return LatestZeroMeasurementDtoFromJSONTyped(json, false);
}

export function LatestZeroMeasurementDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LatestZeroMeasurementDto {
    if (json == null) {
        return json;
    }
    return {
        
        'hasZeroMeasurement': json['hasZeroMeasurement'] == null ? undefined : json['hasZeroMeasurement'],
        'latestExecutionTime': json['latestExecutionTime'] == null ? undefined : json['latestExecutionTime'],
        'zeroMeasurementValidityDuration': json['zeroMeasurementValidityDuration'] == null ? undefined : json['zeroMeasurementValidityDuration'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function LatestZeroMeasurementDtoToJSON(value?: LatestZeroMeasurementDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'hasZeroMeasurement': value['hasZeroMeasurement'],
        'latestExecutionTime': value['latestExecutionTime'],
        'zeroMeasurementValidityDuration': value['zeroMeasurementValidityDuration'],
        '$type': value['$type'],
    });
}

